import _ from 'underscore';
import * as segmentationType from './segmentation-type';

export const segmentationTypeEnum = _.keys(segmentationType);

export const campaignSegmentationTypeEnum = [
  segmentationType.Day,
  segmentationType.Week,
  segmentationType.Month,
  segmentationType.Quarter,
  segmentationType.Year,
  segmentationType.DayOfTheWeek,
  // not used yet
  // segmentationType.HourOfTheDay
  segmentationType.DeviceType,
  segmentationType.Network,
  segmentationType.TopVsOther,
  // not used yet
  // segmentationType.DeliveredMatchType
  // not used yet
  // segmentationType.BiddedMatchType
  // not used yet
  // segmentationType.Medium
  // not used yet
  // segmentationType.Currency
  // not used yet
  // segmentationType.DeviceOS
  // not used yet
  // segmentationType.AdPosition
  // not used yet
  // segmentationType.DomainType
  segmentationType.GoalName,
  segmentationType.GoalType,
  segmentationType.GoalCategory,
  segmentationType.AudienceName,
  segmentationType.AudienceType,
];

/**
 * @see [Segment]{@link https://msasg.visualstudio.com/Bing_Ads/_git/AdInsights#path=%2Fprivate%2FMTv2%2FInterfaces%2FAuctionInsight%2FAuctionInsightCommon.cs&version=GBmaster&_a=contents}
 */
export const adinsightSegmentationTypeEnum = [
  // not used yet
  // segmentationType.Hour
  segmentationType.Day,
  segmentationType.Week,
  segmentationType.Month,
  segmentationType.Quarter,
  segmentationType.Year,
  segmentationType.DayOfWeek,
  segmentationType.Device,
  segmentationType.HourOfDay,
];

/**
 * Segmentation Types that have to do with a period of time only
 */
export const timeSegmentationTypeEnum = [
  segmentationType.Day,
  segmentationType.Week,
  segmentationType.Month,
  segmentationType.Quarter,
  segmentationType.Year,
  segmentationType.DayOfTheWeek,
  // not used yet
  // segmentationType.HourOfTheDay
];
